import { useTranslation } from "react-i18next";
import { ao3Stats } from "@/mocks/ao3Home";
import Ao3Reveal from "./Ao3Reveal";

export default function Ao3Stats() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100 border-y border-background-200/70">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-10 md:py-14">
        <Ao3Reveal className="mb-8 text-center">
          <span className="text-xs font-semibold tracking-[0.2em] text-primary-700 dark:text-primary-400">{t("stats.badge")}</span>
        </Ao3Reveal>
        <div className="grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-4">
          {ao3Stats.map((stat, index) => (
            <Ao3Reveal key={stat.id} delay={index * 80}>
              <div className="flex h-full flex-col items-center gap-2 rounded-lg border border-background-200/70 bg-background-50 px-4 py-6 text-center">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className={`${stat.icon} text-xl leading-none`} />
                </span>
                <span className="font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">{stat.value}</span>
                <span className="text-xs text-foreground-600 md:text-sm">{t(`stats.${stat.id}`)}</span>
              </div>
            </Ao3Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}